module.exports = __webpack_public_path__ + "img/FP&P_COVER.cc321e2b.png";